import React from "react";
import { Clock } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { DEFAULT_WORK_SCHEDULE, WORK_DAY_LABELS } from "@/utils/workSchedule";

const WorkScheduleEditor = ({
  value,
  onChange,
  isDark = false,
  compact = false,
  showTitle = true,
  hint = "Mola analizi bu mesai planına göre hesaplanır.",
}) => {
  const cardClass = isDark
    ? "rounded-xl border border-slate-800 bg-slate-950/50 p-4 space-y-4"
    : "rounded-xl border border-gray-200 bg-gray-50/80 p-4 space-y-4";
  const inputClass = isDark ? "bg-slate-900 border-slate-700 text-white focus:border-purple-500" : "bg-white border-gray-300 focus:border-purple-500";
  const sectionTitleClass = isDark ? "text-sm font-semibold text-slate-200 flex items-center gap-2" : "text-sm font-semibold text-gray-800 flex items-center gap-2";
  const mutedClass = isDark ? "text-slate-500" : "text-gray-500";
  const labelClass = isDark ? "text-slate-300" : "text-gray-700";

  const content = (
    <>
      {showTitle && (
        <>
          <p className={sectionTitleClass}><Clock className="w-4 h-4 text-amber-400" /> Çalışma Günleri ve Saatleri</p>
          {hint && <p className={`text-xs mb-3 ${mutedClass}`}>{hint}</p>}
        </>
      )}
      <div className="space-y-2">
        {WORK_DAY_LABELS.map((day) => {
          const row = value[day.id] || DEFAULT_WORK_SCHEDULE[day.id];
          return (
            <div
              key={day.id}
              className={`grid grid-cols-[auto_1fr_auto_auto] sm:grid-cols-[140px_auto_1fr_1fr] gap-2 items-center rounded-lg px-2 py-1.5 ${isDark ? "bg-slate-900/40" : "bg-white/80"}`}
            >
              <label className={`inline-flex items-center gap-2 text-xs sm:text-sm ${labelClass}`}>
                <Checkbox
                  checked={!!row.enabled}
                  onCheckedChange={(checked) => onChange({
                    ...value,
                    [day.id]: { ...value[day.id], enabled: checked === true },
                  })}
                />
                <span className="whitespace-nowrap">{day.label}</span>
              </label>
              <span className={`hidden sm:inline text-[10px] ${mutedClass}`}>{row.enabled ? "Açık" : "Kapalı"}</span>
              <Input
                type="time"
                value={row.start}
                disabled={!row.enabled}
                onChange={(e) => onChange({
                  ...value,
                  [day.id]: { ...value[day.id], start: e.target.value },
                })}
                className={`${compact ? "h-8" : "h-8"} text-xs ${inputClass}`}
              />
              <Input
                type="time"
                value={row.end}
                disabled={!row.enabled}
                onChange={(e) => onChange({
                  ...value,
                  [day.id]: { ...value[day.id], end: e.target.value },
                })}
                className={`${compact ? "h-8" : "h-8"} text-xs ${inputClass}`}
              />
            </div>
          );
        })}
      </div>
    </>
  );

  if (compact) {
    return <div className="space-y-3">{content}</div>;
  }

  return <div className={cardClass}>{content}</div>;
};

export default WorkScheduleEditor;
